import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var BrandDoesNotHaveInsiderFreeShippingIA = function BrandDoesNotHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize)];
    }
  };
};
var WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE = function WHY_BRAND_DOES_NOT_HAVE_INSIDER_FREE_SHIPPING_ANYMORE(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "N937A2",
    defaultMessage: [{
      "type": 0,
      "value": "Une marque n'offre plus la livraison gratuite avec Insider"
    }]
  }) : strictLocalize({
    id: "82J7WC",
    defaultMessage: [{
      "type": 0,
      "value": "Pourquoi une marque auprès de laquelle j'ai déjà commandé ne propose-t-elle plus la livraison gratuite avec Insider ?"
    }]
  });
};
var FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY = function FREE_SHIPPING_COVERAGE_MAY_CHANGE_PERIODICALLY(strictLocalize) {
  return strictLocalize({
    id: "pKpa9D",
    defaultMessage: [{
      "type": 0,
      "value": "La prise en charge de la livraison gratuite peut changer périodiquement. Par exemple, la prise en charge peut être modifiée lorsque nous procédons à des ajustements en fonction des coûts estimés ou lorsque nous testons de nouveaux facteurs, tels que le type de relation. Cette flexibilité nous permet de proposer la livraison gratuite pour le plus grand nombre de commandes possible, tout en maintenant votre abonnement Insider à un prix abordable. Bien que vous ayez profité de la livraison gratuite avec Insider lors de votre dernière commande auprès d'une marque spécifique, il est possible que celle-ci ne bénéficie plus de la livraison gratuite avec Insider dans le cadre de votre abonnement. Si vous souhaitez trouver d'autres marques proposant la livraison gratuite avec Insider, vous pouvez utiliser le filtre Insider lors de vos achats ou simplement rechercher la clé Insider lorsque vous naviguez sur Faire."
    }]
  });
};